import Hero from "./Hero/Hero";
import Future from "./Future/Future";
import BrandsGrid from "./BrandsGrid/BrandsGrid";
import Culture from "Features/Landing/Culture/Culture";
import Contact from "Features/Landing/Contact/Contact";
import Stats from "./Stats/Stats";

import "./Landing.scss";
/* import LinkedinPosts from "./Linkedin/LinkedinPosts"; */
import ReportSection from "Features/EnviromentPage/ReportSection";
import Commitment from "./Commitment/Commitment";
import { useEffect } from "react";
import { trackEvent } from "Services/Analytics/trackEvent";
import { lazy, Suspense } from "react";
import LazyOnVisible from "Components/LazyOnVisible";

const LazyLinkedinPosts = lazy(() => import("./Linkedin/LinkedinPosts"));

const Landing = () => {
  useEffect(() => {
    trackEvent("landing_page");
  }, []);
  return (
    <main data-testid="landing" className="landing page">
      <Hero />
      <Stats />
      <Future />
      {/* <BrandSlider /> */}
      <BrandsGrid />
      <Commitment />
      <div className="spacing">
        <ReportSection />
        <Culture />
        <Suspense fallback={<div>Cargando...</div>}>
          <LazyOnVisible>
            <LazyLinkedinPosts />
          </LazyOnVisible>
        </Suspense>
        <Contact />
      </div>
    </main>
  );
};

export default Landing;
